import React from 'react'
import { Circle } from 'lucide-react'

export default function AddGoalCard() {
  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded-2xl border-2 border-dashed border-slate-300 bg-slate-100 p-6 transition-all hover:border-indigo-400 hover:bg-indigo-50">
      <div className="rounded-full bg-indigo-100 p-4">
        <span className="material-icons-outlined text-3xl text-indigo-600"></span>
      </div>
      <div className="text-center">
        <h3 className="font-bold text-slate-900">Add a New Goal</h3>
        <p className="mt-1 text-sm text-slate-500">Click the button above to create your next goal</p>
      </div>
    </div>
  )
}
